import React, { ReactElement } from 'react';
import { AppHeader, Skeleton } from '@mindly/ui-components';
import { IonButtons, IonIcon } from '@ionic/react';
import {
  BackButton,
  BookingSteps,
  BookingTitle,
  ChevronHeaderTitle,
  HeaderIcon,
  IconButtons,
} from './ChevronHeader.styled';
import { chevronBackOutline } from 'ionicons/icons';
import { useHistory } from 'react-router';

type BookingHeaderProps = {
  title?: string | ReactElement;
  subTitle?: string;
  route?: string;
  isLoading?: boolean;
  icon?: JSX.Element | string;
  iconOnClickHandler?: () => void;

  iconSize?: 'small' | 'medium' | 'large';
};

const ChevronHeader: React.FC<BookingHeaderProps> = ({
  title,
  subTitle,
  route,
  isLoading,
  icon,
  iconOnClickHandler,
  iconSize,
}) => {
  const history = useHistory();

  return !isLoading ? (
    <AppHeader>
      <IonButtons slot="start">
        <BackButton onClick={() => (route ? history.push(route) : history.go(-1))}>
          <IonIcon icon={chevronBackOutline} />
        </BackButton>
      </IonButtons>
      <ChevronHeaderTitle>
        {title && <BookingTitle>{title}</BookingTitle>}
        {subTitle && <BookingSteps>{subTitle}</BookingSteps>}
      </ChevronHeaderTitle>
      {icon && (
        <IconButtons slot="end">
          {typeof icon === 'string' ? (
            <HeaderIcon
              icon={icon}
              onClick={iconOnClickHandler}
              className={'header-icon'}
              iconSize={iconSize ?? 'medium'}
            />
          ) : (
            icon
          )}
        </IconButtons>
      )}
    </AppHeader>
  ) : (
    <AppHeader>
      <IonButtons slot="start">
        <BackButton onClick={() => (route ? history.push(route) : history.go(-1))}>
          <IonIcon icon={chevronBackOutline} />
        </BackButton>
      </IonButtons>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Skeleton widthPx={60} heightPx={16} />
        <Skeleton widthPx={92} heightPx={14} />
      </div>
    </AppHeader>
  );
};

export default ChevronHeader;
